<input
  #stringInput
  type="text"
  blazeInputMask
  predefinedMask="numberInputMask"
  [maskOptions]="maskOptions"
  [formControl]="formControl"
  [ngStyle]="config?.inputStyles"
  class="string-input"
/>
